import AppsIcon from '@mui/icons-material/Apps';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MailIcon from '@mui/icons-material/Mail';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';

import {getProductUrl} from '../interfaces/products';
import {PRODUCTS} from '../interfaces/products/products.enum';
import {SubNavItem} from '../interfaces/sub-nav-item.interface';
import {SUPPORT_URL} from '../utils/constants';
import {CREATE_PATIENT_ROUTE, MY_PATIENTS_ROUTE} from './routes';

export const SUB_NAV_ITEM_MY_PATIENTS: SubNavItem = {
  to: MY_PATIENTS_ROUTE.path,
  label: MY_PATIENTS_ROUTE.title as string,
  Icon: AppsIcon,
};

export const SUB_NAV_ITEM_SUPPORT: SubNavItem = {
  href: SUPPORT_URL,
  label: 'navigation.help',
  Icon: MenuBookIcon,
};

export const SUB_NAV_ITEM_CALENDAR: SubNavItem = {
  href: getProductUrl(PRODUCTS.Dashboard),
  label: 'navigation.dashboard',
  Icon: CalendarMonthIcon,
};

export const SUB_NAV_ITEM_ACCOUNT: SubNavItem = {
  href: getProductUrl(PRODUCTS.Dashboard),
  label: 'navigation.account',
  Icon: PersonIcon,
};

export const SUB_NAV_ITEM_OP_INBOX: SubNavItem = {
  href: getProductUrl(PRODUCTS.Opplevelser),
  label: 'navigation.inbox',
  Icon: MailIcon,
};

export const SUB_NAV_ITEM_DO: SubNavItem = {
  href: getProductUrl(PRODUCTS.DigitaleOpplevelser),
  label: 'navigation.digitaleOpplevelser',
  Icon: VideoLibraryOutlinedIcon,
};

export const SUB_NAV_ITEM_MIN_MEMORIA: SubNavItem = {
  to: '/',
  label: 'navigation.minMemoria',
  Icon: PeopleIcon,
  isRoot: true,
};

export const SUB_NAV_ITEM_CREATE_PATIENT: SubNavItem = {
  to: CREATE_PATIENT_ROUTE.path,
  label: CREATE_PATIENT_ROUTE.title as string,
  Icon: PersonAddIcon,
};
